import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'vi-head',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './head.component.html',
  styleUrls: ['./head.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViHeadComponent implements OnInit {
  @Input() fixed: boolean;
  @Input() isShadow: Boolean = true;

  @HostBinding('style.position') position: string;
  @HostBinding('style.width') width: string;
  @HostBinding('style.zIndex') zIndex: number;

  ngOnInit(): void {
    this.position = this.fixed ? 'fixed' : 'relative';
    this.width = this.fixed ? '100%' : 'auto';
    this.zIndex = this.fixed ? 10 : 0;
  }
}
